import { pickOrderApi } from "./pickOrder";

export const { useCreateCustomClientBOrderMutation } = pickOrderApi;
